import React from 'react';

export const HtmlText = ({__html, Tag = 'span'}: {__html: string; Tag?: React.ElementType}) => (
    <Tag dangerouslySetInnerHTML={{__html}} />
);
